type localeRegion = {
    [key: string]: string;
};

export const localRegionMap: localeRegion = {
    us: 'America/New_York',
    ca: 'America/Toronto',
    eu: 'Europe/Berlin',
    uk: 'Europe/London',
    de: 'Europe/Berlin',
    fr: 'Europe/Paris',
    it: 'Europe/Rome',
    es: 'Europe/Madrid',
    nl: 'Europe/Amsterdam',
    jp: 'Asia/Tokyo',
    kr: 'Asia/Seoul',
    cn: 'Asia/Shanghai',
    sa: 'Asia/Dubai',
    cis: 'Europe/Moscow',
    au: 'Australia/Sydney',
    za: 'Africa/Johannesburg',
    tw: 'Asia/Taipei',
    br: 'America/Sao_Paulo',
    mx: 'America/Mexico_City',
    ar: 'America/Argentina/Buenos_Aires',
    cl: 'America/Santiago',
    co: 'America/Bogota',
    pe: 'America/Lima',
    py: 'America/Asuncion',
    uy: 'America/Montevideo',
    ve: 'America/Caracas',
    nz: 'Pacific/Auckland',
    sg: 'Asia/Singapore',
    th: 'Asia/Bangkok',
    id: 'Asia/Jakarta',
    ph: 'Asia/Manila',
    vn: 'Asia/Ho_Chi_Minh',
    my: 'Asia/Kuala_Lumpur',
    in: 'Asia/Kolkata',
    ae: 'Asia/Dubai',
    il: 'Asia/Jerusalem',
    is: 'Atlantic/Reykjavik',
};
